import { useEffect, useState } from 'react';
import { listEscalationLevels } from '../../reference-data/reference-data.api';

export interface DeadlineFilterOption {
  text: string;
  value: string;
}

/** The board's level filter: every level, furthest-out first, including deactivated ones a container may still have been notified at. */
export function useLevelFilterOptions(): DeadlineFilterOption[] {
  const [options, setOptions] = useState<DeadlineFilterOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    listEscalationLevels()
      .then((levels) => {
        if (!cancelled) setOptions(levels.filter((level) => level.isActive).map((level) => ({ text: level.label, value: level.id })));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
